
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../../shared/Notifications";
import { NotificationGroup } from "../../../shared/Notifiier";
import { ApiResponseData, BaseService, TournamentService, INotification, ITournamentEditionRegistered, MemberNotificationService, SanitizedResponse, TeamService, ITournamentEditionRegisteredParticipant } from "../../../../services";
import { ConfirmDialog, Siren } from "../../../shared/ConfirmDialog";
import { AlertInterface, Checkbox, useSubscription } from "@rivtn/noseur";
import { Elements } from "../../../shared/Elements";
import { Schemes } from "../../../../utils";
import { showTournamentPass } from "./shared/MatchCard";

export interface YourTourCalendarProps {
    registeredTournamentParticipant: ITournamentEditionRegisteredParticipant;
}

function YourTourCalendar(props: YourTourCalendarProps) {

    const { registeredTournamentParticipant } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.tournaments.your_tournament.calender;
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);

    return (<div className="your-tour-home your-tour-cal">
        <div className="snapper" style={{ justifyContent: "space-between", marginTop: 10 }}>
            <div>
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.show_schedule} onChange={(e: any) => {
                    
                }} />
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.show_other_participant_schedule} style={{ marginTop: 15 }} onChange={(e: any) => {
                    
                }} />
            </div>
            {Elements.buildSnapper(() => {
                showTournamentPass(registeredTournamentParticipant.tournament_edition_registered.tournament_edition.name, labels.design_headers, registeredTournamentParticipant.tournament_edition_registered.soft_cache?.calender_pass_id);
            })}
        </div>
        <div className="calendar">
            <div style={{ backgroundColor: "var(--secondaryPanelBackground)", width: "100%", height: "100%" }}>

            </div>
        </div>
    </div>);

}

export default YourTourCalendar;
